// extracted by mini-css-extract-plugin
export var dummy = "conditions-module--dummy--c7c34";
export var menu_subcontents = "conditions-module--menu_subcontents--6f88e";
export var star = "conditions-module--star--22b39";
export var unstar = "conditions-module--unstar--a8fa0";